import FacebookIcon from '../../../../ui/svg/common/social-icons/facebook';
import TwitterIcon from '../../../../ui/svg/common/social-icons/twitter';
import EmailIcon from '../../../../ui/svg/common/email';
import React from 'react';
import { twitterShare } from '../../../../domain/marketing/twitter-provider';
import { rootActions, useAppDispatch, useAppSelector } from '../dal/store';
import { saveStats } from '../dal/data-service';
import { openWindowPopup } from '../../../../domain/common';

/*
const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
};*/

const marginStyle = {
    marginTop: '-3px',
};

const SocialButtons = () => {
    const dispatch = useAppDispatch();

    const shareUrl = useAppSelector(store => store.root.shareUrl);
    const userWidget = useAppSelector(store => store.root.userWidget);
    const isChina = useAppSelector(store => store.root.isChina);
    const isGdprFunctional = useAppSelector(store => store.root.isGdprFunctional);

    const handleFacebookClick = async () => {
        // const _shareUrl = `${ shareUrl }fb/${ s4() }`;
        const _shareUrl = `${ shareUrl }fb`;
        openWindowPopup(`https://www.facebook.com/sharer/sharer.php?u=${ _shareUrl }`, 'facebook', 600, 400);
        await saveStats('facebook', userWidget?.shortURL || '');
    };

    const handleTwitterClick = async () => {
        const _shareUrl = `${ shareUrl }tw`;
        twitterShare(_shareUrl);
        await saveStats('twitter', userWidget?.shortURL || '');
    };

    const handleEmailClick = () => {
        dispatch(
            rootActions.main({
                emailFormVisible: true,
            })
        );
    };

    return (
        <div className="flex items-center justify-center mb-4">
            {
                !isChina && isGdprFunctional && (
                    <>
                        <button type="button" className="flex items-center text-white font-bold rounded px-4 py-2 mx-2" style={{
                            background: "#3a5795"
                        }} onClick={ handleFacebookClick }>
                            <FacebookIcon title="Share on Facebook" width="8px" height="17px" color="#fff" style={ marginStyle } />
                            <span className="ml-2">SHARE</span>
                        </button>

                        <button type="button" className="flex items-center text-white font-bold rounded px-4 py-2 mx-2" style={{
                            background: "#00a1ee"
                        }} onClick={ handleTwitterClick }>
                            <TwitterIcon title="Share on Twitter" width="21px" height="17px" color="#fff" style={ marginStyle } />
                            <span className="ml-2">TWEET</span>
                        </button>
                    </>
                )
            }

            <button type="button" className="flex items-center text-white font-bold rounded px-4 py-2 mx-2" style={{
                background: "#0061ac"
            }} onClick={ handleEmailClick }>
                <EmailIcon title="Send an Email" width="19px" height="18px" color="#fff" style={ marginStyle } />
                <span className="ml-2">EMAIL</span>
            </button>
        </div>
    )
};

export default SocialButtons;